<div class="p-6 flex flex-col gap-4">
  <app-table
    [config]="connectionpointHistoryTableConfig"
    [data]="tableData"
    [(selectedElements)]="selectedElements">
  </app-table>

  @if (selectedElements.length > 0) {
    <div class="table-wrapper relative shadow-sm">
      <div class="border border-gray-200 dark:border-dark-border rounded-md overflow-hidden">
        <table class="w-full rounded-md table-fixed border-collapse overflow-hidden bg-white dark:bg-dark-card border border-gray-200 dark:border-dark-border">
          <tbody>
            @for (col of dataColumns; track col.title) {
              <tr class="border-b border-gray-200 dark:border-dark-border odd:bg-gray-50 dark:odd:bg-dark-hover">
                <th class="w-64 text-left px-2 py-2 font-normal border-r border-gray-200 dark:border-dark-border dark:text-dark-text">{{ col.title | translate }}
                </th>
                @for (element of selectedElements; track element; let j = $index) {
                  <td class="text-primary dark:text-dark-text py-2 px-2 border-slate-200 truncate">
                    <app-table-cell
                      [config]="col"
                      [data]="element"
                    ></app-table-cell>
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  }

</div>
